import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

// Sizes/variants follow concept2 prototype (docs/studio/design-concept2/src/primitives.jsx Chip).
// Smaller than Badge: padding 2/8 px = py-0.5 px-2; fontSize 11; mono font; rounded 6 = rounded-md.
// Variants use subtle backgrounds (token / opacity mix) for low-emphasis labels.
const chipVariants = cva(
  "inline-flex items-center gap-1 rounded-md px-2 py-0.5 font-mono text-[11px]",
  {
    variants: {
      variant: {
        default: "bg-muted text-muted-foreground",
        primary: "bg-primary/[0.12] text-primary",
        success: "bg-success/[0.15] text-success",
        warning: "bg-warning/[0.15] text-[hsl(38_92%_30%)] dark:text-[hsl(38_92%_60%)]",
        info: "bg-info/[0.12] text-info",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface ChipProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof chipVariants> {}

const Chip = React.forwardRef<HTMLSpanElement, ChipProps>(
  ({ className, variant, ...props }, ref) => (
    <span ref={ref} className={cn(chipVariants({ variant }), className)} {...props} />
  )
)
Chip.displayName = "Chip"

export { Chip, chipVariants }
